export default {
	"subscribe.AccordingTo": "( 按",
	"subscribe.deduction": "扣費第",
	"subscribe.Expect": "期 )",
	"subscribe.PaymentTime": "支付時間：",
	"subscribe.OrderNumber": "訂單編號：",
	"subscribe.UnfortunatelyNoMatchingDataWasFound": "非常遺憾，沒有找到符合條件的數據",
	"subscribe.loadMore": "加載更多"
}